import { createAction, props } from '@ngrx/store';
import { Vehicle } from '../../models/master-data/vehicle.model';


export const loadVehicles = createAction('[Vehicle] Load Vehicles');
export const loadVehiclesSuccess = createAction('[Vehicle] Load Vehicles Success', props<{ vehicles: Vehicle[] }>());
export const addVehicle = createAction('[Vehicle] Add Vehicle', props<{ vehicle: Vehicle }>());
export const addVehicleSuccess = createAction( '[Vehicle] Add Vehicle Success',props<{ vehicle: Vehicle; message: string }>());
export const updateVehicle = createAction('[Vehicle] Update Vehicle', props<{ vehicle: Vehicle }>());
export const updateVehicleSuccess = createAction( '[Vehicle] Update Vehicle Success',props<{ vehicle: Vehicle; message: string }>());
export const deleteVehicle = createAction('[Vehicle] Delete Vehicle', props<{ id: number }>());
export const deleteVehicleSuccess = createAction( '[Vehicle] Delete Vehicle Success',props<{ message: string,  id:number }>());
export const loadVehiclesFailure = createAction('[Vehicle] Load Vehicles Failure', props<{ error: string }>());